import { styled } from '@mui/material';
import { ReactNode, MouseEvent } from 'react';

export type SidebarButtonProps = {
  children: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
};

const StyledButton = styled('button')(({ theme }) => ({
  background: 'var(--color-neutral-300)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  border: 'none',
  width: theme.constants.sidebarButtonWidth,
  minHeight: theme.constants.sidebarButtonWidth,
  cursor: 'pointer',
  padding: 6,
  '&:hover': {
    background: 'var(--color-neutral-400)',
  },
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
}));

export const SidebarButton = ({ children, onClick }: SidebarButtonProps) => {
  return <StyledButton onClick={onClick}>{children}</StyledButton>;
};
